// translations.ts
var translations = {
  "connection-status-alert": {
    onlineAgain: ["Du bist wieder Online", "You are back online"],
    offline: ["Du bist Offline ", "You are offline"],
    offlineLong: [
      "Es sieht so aus, als ob du nicht mit dem Internet verbunden bist.",
      "It seems you are not connected to the internet."
    ],
    checkConnection: ["Bitte \xFCberpr\xFCfe deine Internetverbindung", "Please check your internet connection"]
  }
};
export {
  translations
};
